import React from 'react';
import { Typography } from '@mui/material';

function BlogParagraph({ children, ...props}) {
  return (
    <Typography variant="p" component="p" sx={{ my: 2 }} {...props}>
      {children}
    </Typography>
  )
}

export default BlogParagraph;
